module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row"
  }, [_vm._l((_vm.table_data_list), function(item) {
    return [_c('el-col', {
      staticClass: "col",
      attrs: {
        "span": 12
      }
    }, [_c('SimpleTable', {
      attrs: {
        "title": item.name,
        "srcdata": item.data,
        "config": item.config
      }
    })], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c905c4ea"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/home/HomeBody.vue
// module id = 260
// module chunks = 2